<template>
  <Modal v-if="balanceInfo" width="1000" class="align-l" v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">{{`${projectName}.${roomNum}`}}</div>

    <div class="item pt16 pb16">
      <h4 class="mb8">结算明细</h4>
      <table-list :showPage ="false" :columns="balanceColumns" :data="balanceInfo" :loading="balanceLoading"></table-list>
    </div>

    <div class="notopcheck" style="margin-top: 32px;">
      <h4 class="mb8">未核销账单</h4>
      <!--<Table ref="billTable" :data="dataBill" :columns="columnsBill" ></Table>-->
      <div>
        <Row class="row">
          <Col span="5">帐单编号</Col>
          <Col span="5">费用项</Col>
          <Col span="5">账单金额</Col>
          <Col span="5">核销状态</Col>
          <Col span="4"></Col>
        </Row>
        <Row class="row" v-for="item,index in dataBill" :key="'keyTF'+index">
          <Col span="5">{{item.billNumber}}</Col>
          <Col span="5">{{item.finExpenseItemName || '-'}}</Col>
          <Col span="5" style="text-align: right">{{Number(item['feeAmount']/100).toFixed(2)}}</Col>
          <Col span="5">{{item.verificateStatusName}}</Col>
          <Col span="4">
            <Checkbox v-model="item.selected" @on-change="checkNoItem(item)" disabled></Checkbox>
          </Col>
        </Row>
        <div v-if="!dataBill.length"  class="row ivu-row">暂无数据</div>


      </div>
    </div>

    <div slot="footer">
      <Button type="primary" size="large" @click="close">确定</Button>
    </div>

  </Modal>
</template>

<script type="text/ecmascript-6">
import defaultImg from '@/assets/filedefault.jpg'
import TableList from "components/TableList/index";

import {getNoCancelBillsInfo} from "../../../../../api/contractList";

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    projectName:{
      type: String,
      default:''
    },
    roomNum:{
      type:String,
      default:''
    },
    balanceInfo:{
      type:Array,
      default:null

    },
    surrenderFid:{
      type:String,
      default:''
    },
    nocancelSurFid:{
      type:String,
      default:''

    }
  },
  watch:{
    n(val){
      // 重新获取交割数据
      this.dataBill=[]

      this.getNoCancelBillsInfo()

      this.show = true
    }
  },
  components:{
    TableList
  },
  // created(){
  //   this.getNoCancelBillsInfo()
  //
  //
  // },
 data () {
  return {
    columnsBill: [
      {
        title: "帐单编号",
        key: "billNumber",
        align: "center"
      },
      {
        title: "费用项",
        key: "finExpenseItemName",
        align: "center"
      },
      {
        title: "账单金额",
        key: "feeAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }
          },Number(params.row['feeAmount']/100).toFixed(2))

        },

      },
      {
        title: "核销状态",
        key: "verificateStatusName",
        align: "center"
      },

      {
        // type: 'selection',
        key:'action',
        width: 60,
        align: 'center',
        render:(h,params)=>{
          // console.log(params.row['selected'])
          return h('Checkbox',{
            props: {
              value: params.row['selected'],
              disabled:true
            },
          })

        }
      },

    ],
    dataBill: [],
    show:false,
    balanceLoading:false,
    balanceColumns:[
      {
        title: "费用项",
        key: "expenseItemName",
        align: "center"

      },
      {
        title: "应缴费用",
        key: "receivableAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['receivableAmount'])
        },

      },
      {
        title: "已缴费用",
        key: "receivedAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['receivedAmount'])
        },

      },
      {
        title: "应退费用",
        key: "refundAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['refundAmount'])
        },


      },
      {
        title: "实退费用",
        key: "actRefundAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['actRefundAmount'])
        },

      }
    ],
    balanceList:[],
 };
 },
 methods:{
close() {
  this.show = false
},
   getNoCancelBillsInfo() {
     let params = {
       surrenderFid: this.nocancelSurFid
     }
     getNoCancelBillsInfo(params).then(res => {
       if(!res.data){
         return
       }
       this.dataBill=res.data

     }).catch(error => {
       // let res = [{
       //   "billNumber": "string",
       //   "cancelBillFid": "string",
       //   "feeAmount": 0,
       //   "finExpenseItemName": "水费",
       //   "verificateStatus": 0,
       //   "verificateStatusName": "string"
       // }]

       // this.dataBill = res

     })

   },
 }
}
</script>
<style scoped>
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }
  .info {
    padding-left: 8px;
    font-weight: 600;
  }

  .table-wrap {
    position: relative;
    border: 1px solid #dddee1;
    border-bottom: 0;
    border-right: 0;
  }

  table {
    width: 100%;
  }

  th, td {
    text-align: center;
  }
</style>
